import {Component, Inject, OnInit} from '@angular/core';
import {UtilsService} from "../../shared/utils.service";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import {ToolsFilters} from "./tools-filter.interface";

@Component({
  selector: 'app-tools-filter',
  templateUrl: './tools-filter.component.html',
  styleUrls: ['./tools-filter.component.scss']
})
export class ToolsFilterComponent implements OnInit {

  filters: ToolsFilters = {
    industry_id: '',
    industries: [],
    archived: 'false',
    archived_hidden: false
  } as ToolsFilters;

  constructor(
    private utils: UtilsService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<ToolsFilterComponent>
  ) {
    // set a default industry id selection of zero if no selected values are passed through
    if (typeof this.data['selected_industry_id'] === 'undefined') {
      this.data['selected_industry_id'] = '';
    }

    // set a default archived value of false if no values are passed through
    if (typeof this.data['filter_archived'] === 'undefined') {
      this.data['filter_archived'] = "false";
    }

    // set a default archived hidden value of true if no values are passed through
    if (typeof this.data['filter_archived_hidden'] === 'undefined') {
      this.data['filter_archived_hidden'] = false;
    }
  }

  ngOnInit() {
    this.getIndustries();

    this.filters.industry_id = this.data['selected_industry_id'];
    this.filters.archived = this.data['filter_archived'];
    this.filters.archived_hidden = this.data['filter_archived_hidden'];
  }

  private async getIndustries() {
    this.filters.industries = await this.utils.getIndustries();
  }

  onClearAndClose() {
    this.filters.industry_id = '';
    this.filters.archived = "false";

    this.onSaveAndClose();
  }

  onSaveAndClose() {
    let response: any;

    response = {
      industry_id: this.filters.industry_id,
      archived: this.filters.archived
    }

    this.dialogRef.close(response);
  }

}
